import React, { Component } from 'react';

import ServerTreeComponent from './ServerTreeComponent'
import { actions } from './ServerTreeReducer'
import { connect } from 'react-redux'

class Wrapper extends Component {
    componentDidMount() {
        this.props.fetch();
    }
    render() {
        return (
            <React.Fragment>
                <ServerTreeComponent {...this.props} />                
            </React.Fragment>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        fetcher: state.waas.serverTree.fetcher,
        isLoading: state.waas.serverTree.serverTree.isLoading || state.waas.serverTree.fetcher.loading,
        items: state.waas.serverTree.fetcher.items || []
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        fetch: () => {
            dispatch(actions.trigger())
        },
        reload: () => {
            dispatch(actions.trigger())
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Wrapper)